<template>
  <tr class="single-item singleItemForModal">
    <td data-title="商品"><img :src="itemInfo.photo" /></td>
    <td data-title="商品編號">{{ itemInfo.product_id }}</td>
    <td data-title="商品名稱">{{ itemInfo.name }}</td>
    <td data-title="規格">
      <ul class="singleItemForModal-spec">
        <li
          v-for="(spec, index) in itemInfo.product_specs"
          :key="spec.prduct_spec_id"
          class="square-radio"
        >
          <input
            :id="'id' + spec.product_spec_id + index"
            v-model="chooseSpecId"
            :value="spec.product_spec_id"
            type="radio"
          />
          <label :for="'id' + spec.product_spec_id + index">
            {{ spec.first_spec_name + (spec.second_spec_name || '') }}
          </label>
        </li>
      </ul>
    </td>
    <td data-title="單價" v-if="modalType === 'additionalPrice'">
      {{ itemInfo.price }}
    </td>
    <td data-title="加購價" v-if="modalType === 'additionalPrice'">
      {{ itemInfo.price }}
    </td>
    <td data-title="數量">
      <b-form-spinbutton
        v-if="modalType === 'additionalPrice'"
        v-model="count"
        min="0"
        :max="countMaxAddbuy"
        :disabled="chooseSpecId < 0"
      ></b-form-spinbutton>
      <b-form-spinbutton
        v-if="modalType === 'freebies'"
        v-model="count"
        min="0"
        :max="freebiesMax || countMaxFreebies"
        :disabled="!canPick || chooseSpecId < 0"
      ></b-form-spinbutton>
    </td>
  </tr>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    itemInfo: {
      type: Object,
      default: () => ({})
    },
    modalType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      canPick: true,
      freebiesMax: 0
    };
  },
  computed: {
    ...mapState('order', ['discount', 'discountItems', 'freebies']),

    count: {
      get() {
        return this.itemInfo.count;
      },
      set(count) {
        this.$store.commit('order/updateDiscountItemCount', {
          count,
          product_id: this.itemInfo.product_id
        });
      }
    },
    // 加價購商品可購買的最大值
    countMaxAddbuy() {
      const idx = this.itemInfo.product_specs.findIndex(
        info => info.product_spec_id === this.chooseSpecId
      );

      return this.itemInfo.product_specs[idx]?.in_stock;
    },
    // 贈品在 modal 可選的最大值
    countMaxFreebies() {
      // 用戶可以選的贈品數量 - 已經加入購物車的贈品數量
      return this.discount.freebie_limit - this.freebiesCurrentTotal;
    },
    // 當前已經加到購物車的贈品數量
    freebiesCurrentTotal() {
      return this.freebies.reduce((acc, cur) => {
        acc += cur.count;
        return acc;
      }, 0);
    },
    // modal 中選擇的贈品數量
    freebiesModalTotal() {
      return this.discountItems.reduce((acc, cur) => {
        acc += cur.count;
        return acc;
      }, 0);
    },
    // 當前選中的規格 id, 預設值在 store 中給 -1, 選中規格後重新設置 id, 隨後才可以選擇數量
    chooseSpecId: {
      get() {
        return this.itemInfo.model_id;
      },
      set(specId) {
        const idx = this.itemInfo.product_specs.findIndex(
          info => specId === info.product_spec_id
        );

        this.$store.commit('order/updateDiscountItemSpec', {
          chooseSpec: this.itemInfo.product_specs[idx],
          product_id: this.itemInfo.product_id
        });
      }
    }
  },
  watch: {
    freebiesModalTotal(val) {
      // 如果贈品在 modal 選到上限
      if (val === this.countMaxFreebies) {
        // 把數量為 0 的數量增減 disabled
        if (this.count === 0) {
          this.canPick = false;
        } else {
          // 把數量不為 0 的數量增減最大值設為當前值
          this.freebiesMax = this.count;
        }
      } else {
        // 如果贈品在 modal 沒選到上限，就重置數量增減的參數
        this.freebiesMax = 0;
        this.canPick = true;
      }
    }
  }
};
</script>
